const DATE_PICKER_RANGE_TYPE = {
  startDate: 'from',
  endDate: 'to',
};

export default DATE_PICKER_RANGE_TYPE;